import { extendTheme, ThemeConfig } from '@chakra-ui/react';

const config: ThemeConfig = {
  initialColorMode: 'light',
  useSystemColorMode: false,
};

const theme = extendTheme({
  colors: {
    brand: {
      50: '#e3f2ff',
      100: '#b3daff',
      200: '#81c2ff',
      300: '#4faaff',
      400: '#1e92ff',
      500: '#0579e6',
      600: '#005fb4',
      700: '#004582',
      800: '#002c51',
      900: '#001320',
    },
  },
  fonts: {
    heading: `"Roboto", serif, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue' !important;`,

    body: `"Roboto", sans-serif, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue' !important;`
  },
  config,
});

export default theme;